import { Component, ReactNode } from 'react';
import { Box } from '@bridebook/ui';
import componentStyles from './slide.style';

interface IProps {
  loader?: ReactNode;
  lazyLoad?: boolean;
  active?: boolean;
  children: ReactNode;
}

interface IState {
  loaded: boolean;
  isMounted: boolean;
}

export default class Slide extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      loaded: false,
      isMounted: false,
    };
  }

  node?: HTMLElement;

  componentDidUpdate() {
    const { lazyLoad, active } = this.props;
    if ((lazyLoad && !active) || this.state.loaded) return;
    this.loadImage();
  }

  componentDidMount() {
    this.setState({ isMounted: true });
    const { lazyLoad, active } = this.props;
    if (lazyLoad && !active) return;
    this.loadImage();
  }

  componentWillUnmount() {
    this.setState({ isMounted: false });
  }

  loadImage = () => {
    const img = this.node?.querySelector('img');
    if (img) {
      img.onload = () => {
        this.imageLoaded();
      };
    } else {
      this.imageLoaded();
    }
  };

  imageLoaded = () => {
    if (this.state.isMounted) {
      this.setState({ loaded: true });
    }
  };

  render() {
    const { lazyLoad, active, loader, children } = this.props;

    const slideInner = lazyLoad && !this.state.loaded && !active ? <span /> : children;

    const styles = componentStyles();

    return (
      <Box
        style={styles.wrapper}
        setRef={(node: HTMLElement) => {
          this.node = node;
        }}
        data-name="slider-slide">
        {loader && !this.state.loaded && <Box style={styles.loaderWrap}>{loader}</Box>}
        {slideInner}
      </Box>
    );
  }
}
